import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockID, setAttributes } ) {
	const unique = `.wp-block-alpha-blocks-alpha-text.block-${ blockID }`;
	const {
		align,
		color,
		typography,
		backgroundColor,
		containerBorder,
		margin,
		padding,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.css( 'text-align', align ),
			GenerateCss.textColor( color ),
			GenerateCss.typography( typography ),
			GenerateCss.background( backgroundColor ),
			GenerateCss.border( containerBorder ),
			GenerateCss.margin( margin ),
			GenerateCss.padding( padding ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
